import { apiRequest } from '../../../constants/apiRequest';

import { API_ENDPOINTS, HTTP_METHODS } from '../../../constants/appConstants';
import { COMAPANY_ID } from '../../../constants/companyConfig';

const uploadFile = async (uploadUrl, file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(uploadUrl, {
      method: 'PUT', // Sometimes it's `POST`, check API docs
      body: file, // Some APIs require `formData` instead
      headers: {
        'Content-Type': file.type, // Ensure correct file type
      },
    });

    if (response.ok) {
      console.log('File uploaded successfully');
      return 'success';
    } else {
      console.error('File upload failed:', response.statusText);
      return 'failed';
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    return 'error';
  }
};

/*const fetchFileFromUri = async (uri, fileName, fileType) => {
    try {
      const response = await fetch(uri);
      const blob = await response.blob();
      return new File([blob], fileName, { type: fileType });
    } catch (error) {
      console.error("Error fetching image:", error);
      return null;
    }
  };*/

export const uploadImageToAWS = async (
  uploadImage,
  workflowId,
  nodeId,
  token,
  handleLogout
) => {
  // console.log(uploadImage,'hsghgdh')
  if (!uploadImage) {
    console.error('Invalid image data:', uploadImage);
    return 'Invalid image';
  }

  // const fileToUpload = await fetchFileFromUri(uploadImage.uri, uploadImage.name, uploadImage.type);
  // if (!fileToUpload) return "File conversion failed";
  const ImageFileName = uploadImage.name.replace(/\.(jpeg|png|jpg)$/, '');
  //console.log(ImageFileName,'ImageFileName');
  const uploadResponse = await apiRequest(
    API_ENDPOINTS.UPLOAD_IMAGE_API,
    HTTP_METHODS.POST,
    {
      wfwId: workflowId,
      wfwNodeId: nodeId,
      companyId: COMAPANY_ID,
      type: 'image',
      contentType: uploadImage.type,
      purpose: 'image_urls',
      fileName: ImageFileName,
    },
    token,
    handleLogout
  );

  if (uploadResponse?.isUpdated) {
    // console.log("Image uploaded successfully to AWS");

    const uploadStatus = await uploadFile(
      uploadResponse.uploadUrl,
      uploadImage
    );
    return uploadStatus === 'success' ? 'Upload successful' : 'Upload failed';
  } else {
    console.error('Image upload failed:', uploadResponse);
    return 'Image upload failed';
  }
};

export const downloadImageFromAWS = async (
  workflowId,
  nodeId,
  token,
  handleLogout
) => {
  try {
    const apiUrl = `${API_ENDPOINTS.DOWNLOAD_IMAGE_API}?wfwId=${workflowId}&wfwNodeId=${nodeId}&type=image&companyId=${COMAPANY_ID}&purpose=image_urls`;

    const downloadResponse = await apiRequest(
      apiUrl,
      HTTP_METHODS.GET,
      {},
      token,
      handleLogout
    );

    if (downloadResponse?.downloadUrl) {
      console.log('Download success', downloadResponse);
      return downloadResponse.downloadUrl; // Assuming the response contains image data
    } else {
      console.error('Image download failed:', downloadResponse);
      return null;
    }
  } catch (error) {
    console.error('Error downloading image:', error);
    return null;
  }
};
